/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountAssessmentDetails {
    getFixupPrototypeFunction() { return ServiceAccountAssessmentDetails.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountAssessmentDetails>): ServiceAccountAssessmentDetails {
        let obj = Object.assign(new ServiceAccountAssessmentDetails(), model);
        ServiceAccountAssessmentDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountAssessmentDetails>): ServiceAccountAssessmentDetails {
        if (!model) return null;
        return ServiceAccountAssessmentDetails.newInstance(<ServiceAccountAssessmentDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountAssessmentDetails) {
        if (!obj) return;

        models.ServiceAccountAssessmentDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountAssessmentDetails): boolean {
        Object.setPrototypeOf(obj, ServiceAccountAssessmentDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.score === undefined) {
            this.score = 0;
        }
    }

    /**
     * Assessment Score
     */
    score: number;

    /**
     * Assessment Grade
     */
    grade: string;

    /**
     * Last Assessment Time
     */
    last_assessed_time: string;

}
